import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitomahabaleshwarcab() {



    const cardData = {

     keyword: "Mumbai to Mahabaleshwar Cab",

headingDescription:
    "Mumbai Airport Cab offers safe, comfortable, and dependable Mumbai to Mahabaleshwar Cab services for families, couples, corporate travelers, and weekend vacationers. We provide well-maintained Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus options with experienced chauffeurs for a smooth journey through the scenic Western Ghats. With doorstep pickup across Mumbai, Mumbai Airport transfers, one-way and round-trip cab bookings, customized sightseeing plans, 24/7 customer support, and transparent pricing, we ensure a relaxing and memorable trip to the beautiful hill station of Mahabaleshwar.",

topPlaces: [
    {
        title: "Venna Lake",
        description:
            "Venna Lake is one of the most visited attractions in Mahabaleshwar, surrounded by lush greenery and rolling hills. Visitors can enjoy boating, horse riding, local snacks, and peaceful walks along the lakeside. The cool climate and scenic surroundings make it a perfect destination for families, couples, and nature lovers visiting Mahabaleshwar from Mumbai."
    },
    {
        title: "Arthur's Seat",
        description:
            "Arthur's Seat is among the most famous viewpoints in Mahabaleshwar, offering spectacular views of deep valleys, dense forests, and the Savitri River. Often called the 'Queen of Points,' this location is ideal for photography and sightseeing. The pleasant atmosphere and panoramic landscapes attract tourists throughout the year."
    },
    {
        title: "Mapro Garden",
        description:
            "Mapro Garden is a popular family attraction known for its strawberry products, fresh fruit beverages, chocolates, and beautiful gardens. Visitors can enjoy delicious local cuisine, seasonal strawberry picking, and shopping for fruit-based products. It is a favorite stop for travelers visiting Mahabaleshwar and Panchgani."
    },
    {
        title: "Elephant's Head Point",
        description:
            "Elephant's Head Point is a naturally formed rock structure resembling an elephant's head and trunk. The viewpoint offers breathtaking views of the Sahyadri mountain ranges and deep valleys below. It is especially popular during sunrise and sunset when the surrounding landscapes become even more picturesque."
    },
    {
        title: "Wilson Point",
        description:
            "Wilson Point is the highest point in Mahabaleshwar and is famous for its spectacular sunrise views. The location features multiple observation platforms offering panoramic views of the surrounding mountains and valleys. Tourists visit this peaceful destination to experience the refreshing climate and scenic beauty."
    },
    {
        title: "Lingmala Waterfall",
        description:
            "Lingmala Waterfall is a beautiful natural attraction surrounded by forests and green hills. During the monsoon season, the waterfall becomes especially impressive with abundant water flow and misty surroundings. Visitors enjoy nature walks, photography, and the peaceful environment away from the busy town center."
    },
    {
        title: "Pratapgad Fort",
        description:
            "Pratapgad Fort is a historic hill fort associated with the legendary Maratha ruler Chhatrapati Shivaji Maharaj. The fort offers magnificent views of the surrounding valleys and houses important historical monuments and temples. It is a must-visit destination for history enthusiasts and travelers exploring Mahabaleshwar."
    },
    {
        title: "Mahabaleshwar Temple",
        description:
            "The ancient Mahabaleshwar Temple is dedicated to Lord Shiva and is one of the region's most sacred pilgrimage sites. Built in traditional architectural style, the temple attracts devotees and tourists alike for its spiritual significance and historical heritage. It forms an important part of the Mahabaleshwar sightseeing circuit."
    },
    {
        title: "Panchgani",
        description:
            "Located close to Mahabaleshwar, Panchgani is a charming hill station famous for Table Land, Sydney Point, Parsi Point, strawberry farms, and pleasant weather. Many travelers combine Panchgani with their Mahabaleshwar tour to enjoy additional scenic attractions, adventure activities, and family-friendly sightseeing opportunities."
    },
    {
        title: "Connaught Peak",
        description:
            "Connaught Peak is one of the most scenic viewpoints in Mahabaleshwar, offering panoramic views of Venna Lake, Krishna Valley, and the surrounding mountain ranges. The peaceful atmosphere and cool breeze make it a perfect location for relaxation, photography, and enjoying the natural beauty of the Western Ghats during a Mumbai to Mahabaleshwar cab trip."
    }
],



     services: [
{
name: "Mumbai to Mahabaleshwar Cab",
description: "Mumbai Airport Cab offers Mumbai to Mahabaleshwar Cab service for comfortable and hassle-free hill station travel. We provide AC Sedan, SUV, Ertiga, Innova Crysta, and premium vehicles with experienced drivers for one way, round trip, family vacations, corporate travel, and weekend getaways. Enjoy doorstep pickup, transparent pricing, flexible travel schedules, and safe journeys through the scenic Western Ghats."
},
{
name: "Mumbai to Mahabaleshwar Taxi",
description: "Book Mumbai to Mahabaleshwar Taxi with Mumbai Airport Cab for reliable long-distance travel. Our clean vehicles, professional chauffeurs, and 24x7 booking support ensure a smooth and comfortable journey for families, couples, and business travelers."
},
{
name: "Mumbai to Mahabaleshwar Taxi Fare",
description: "Get affordable Mumbai to Mahabaleshwar Taxi Fare with Mumbai Airport Cab. We offer transparent pricing, competitive packages, and comfortable vehicles without hidden charges for one way and round trip travel."
},
{
name: "Car from Mumbai to Mahabaleshwar",
description: "Hire a Car from Mumbai to Mahabaleshwar with Mumbai Airport Cab for convenient and comfortable travel. Choose from Sedan, SUV, Ertiga, and Innova Crysta options suitable for individuals, families, and groups."
},
{
name: "Cab Service from Mumbai to Mahabaleshwar",
description: "Mumbai Airport Cab provides Cab Service from Mumbai to Mahabaleshwar with professional drivers, well-maintained vehicles, and flexible pickup and drop locations for a stress-free travel experience."
},
{
name: "Cab Fare from Mumbai to Mahabaleshwar",
description: "Check Cab Fare from Mumbai to Mahabaleshwar with Mumbai Airport Cab for affordable and value-for-money travel packages. We provide fixed pricing and quality service for all passengers."
},
{
name: "Car Hire from Mumbai to Mahabaleshwar",
description: "Book Car Hire from Mumbai to Mahabaleshwar with Mumbai Airport Cab for premium outstation travel. Enjoy comfortable seating, AC vehicles, and experienced chauffeurs for a memorable trip."
},
{
name: "Mumbai Mahabaleshwar Taxi Hire",
description: "Mumbai Airport Cab offers Mumbai Mahabaleshwar Taxi Hire for holiday trips, sightseeing tours, family vacations, and weekend escapes with safe and comfortable transportation."
},
{
name: "Mumbai to Mahabaleshwar Cab Booking",
description: "Book Mumbai to Mahabaleshwar Cab Booking instantly with Mumbai Airport Cab. Choose your preferred vehicle, schedule, and travel plan with easy reservation and 24x7 customer support."
},
{
name: "Mumbai to Mahabaleshwar Cab Service",
description: "Our Mumbai to Mahabaleshwar Cab Service provides safe and reliable intercity travel with experienced drivers, premium vehicles, and flexible one way and round trip packages."
},
{
name: "Mumbai to Mahabaleshwar Car Hire",
description: "Mumbai Airport Cab offers Mumbai to Mahabaleshwar Car Hire for private travel with comfortable AC vehicles and customized itineraries for families and tourists."
},
{
name: "Mumbai to Mahabaleshwar Car Rental",
description: "Book Mumbai to Mahabaleshwar Car Rental with Mumbai Airport Cab for affordable and comfortable long-distance travel with a wide range of vehicle options."
},
{
name: "Mumbai to Mahabaleshwar Car Rental Price",
description: "Get the best Mumbai to Mahabaleshwar Car Rental Price with Mumbai Airport Cab. We provide competitive rates and quality service for all categories of travelers."
},
{
name: "Mumbai to Mahabaleshwar One Way Taxi",
description: "Mumbai Airport Cab offers Mumbai to Mahabaleshwar One Way Taxi for convenient drop-only travel with affordable fares, professional drivers, and comfortable vehicles."
},
{
name: "Taxi for Mahabaleshwar from Mumbai",
description: "Book Taxi for Mahabaleshwar from Mumbai with Mumbai Airport Cab for reliable transportation, comfortable rides, and flexible travel schedules."
},
{
name: "Mumbai to Panchgani Cab",
description: "Mumbai Airport Cab provides Mumbai to Panchgani Cab for scenic hill station travel with safe driving, premium vehicles, and customized family tour packages."
},
{
name: "Mumbai to Panchgani Cab Fare",
description: "Check Mumbai to Panchgani Cab Fare with Mumbai Airport Cab for affordable pricing and reliable travel solutions with no hidden costs."
},
{
name: "Mumbai to Panchgani Car Rental",
description: "Book Mumbai to Panchgani Car Rental with Mumbai Airport Cab for comfortable travel in Sedan, SUV, Ertiga, and Innova Crysta vehicles."
},
{
name: "Mumbai to Panchgani Taxi",
description: "Mumbai Airport Cab offers Mumbai to Panchgani Taxi service for one way and round trip journeys with experienced drivers and clean AC vehicles."
},
{
name: "Mumbai to Panchgani Taxi Fare",
description: "Get affordable Mumbai to Panchgani Taxi Fare with Mumbai Airport Cab and enjoy safe, comfortable, and budget-friendly hill station travel."
},
{
name: "Mumbai to Tapola Cab",
description: "Mumbai Airport Cab provides Mumbai to Tapola Cab service for nature lovers and tourists visiting Mini Kashmir. Enjoy comfortable vehicles, flexible itineraries, and professional drivers."
},
{
name: "Mumbai Airport to Mahabaleshwar Taxi",
description: "Book Mumbai Airport to Mahabaleshwar Taxi with Mumbai Airport Cab for direct airport pickup and comfortable hill station transfers. We provide flight tracking, doorstep service, premium vehicles, and experienced chauffeurs for a smooth and relaxing journey."
}
],

tableData: [
["Mumbai to Mahabaleshwar Cab","Mumbai to Mahabaleshwar Taxi"],
["Mumbai to Mahabaleshwar Taxi Fare","Car from Mumbai to Mahabaleshwar"],
["Cab Service from Mumbai to Mahabaleshwar","Cab Fare from Mumbai to Mahabaleshwar"],
["Car Hire from Mumbai to Mahabaleshwar","Mumbai Mahabaleshwar Taxi Hire"],
["Mumbai to Mahabaleshwar Cab Booking","Mumbai to Mahabaleshwar Cab Service"],
["Mumbai to Mahabaleshwar Car Hire","Mumbai to Mahabaleshwar Car Rental"],
["Mumbai to Mahabaleshwar Car Rental Price","Mumbai to Mahabaleshwar One Way Taxi"],
["Taxi for Mahabaleshwar from Mumbai","Mumbai to Panchgani Cab"],
["Mumbai to Panchgani Cab Fare","Mumbai to Panchgani Car Rental"],
["Mumbai to Panchgani Taxi","Mumbai to Panchgani Taxi Fare"],
["Mumbai to Tapola Cab","Mumbai Airport to Mahabaleshwar Taxi"]
],




      whychoose: [
{
WhyChooseheading: "Comfortable Mumbai to Mahabaleshwar Cab Service",
WhyChoosedescription: "Mumbai Airport Cab Service offers reliable Mumbai to Mahabaleshwar cab transportation for families, couples, tourists, corporate travelers, and weekend vacationers seeking a pleasant journey."
},
{
WhyChooseheading: "Direct Travel to Popular Hill Station",
WhyChoosedescription: "Mahabaleshwar is one of Maharashtra’s most visited hill stations, and our cab service provides convenient door-to-door transportation from Mumbai."
},
{
WhyChooseheading: "Perfect for Weekend Getaways",
WhyChoosedescription: "Our Mumbai to Mahabaleshwar cab service is ideal for short vacations, family outings, honeymoon trips, and relaxing weekend escapes."
},
{
WhyChooseheading: "Multiple Vehicle Choices Available",
WhyChoosedescription: "Customers can choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles based on travel requirements."
},
{
WhyChooseheading: "One-Way and Round Trip Facilities",
WhyChoosedescription: "We provide flexible booking options including one-way transfers, round trips, multi-day packages, and customized itineraries."
},
{
WhyChooseheading: "Pickup Available Across Mumbai",
WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Andheri, Borivali, Thane, Navi Mumbai, Dadar, Bandra, Powai, and nearby areas."
},
{
WhyChooseheading: "Safe and Professional Travel Experience",
WhyChoosedescription: "Our experienced drivers and regularly maintained vehicles ensure a comfortable, secure, and stress-free journey to Mahabaleshwar."
},
{
WhyChooseheading: "Suitable for Families and Group Travelers",
WhyChoosedescription: "Whether traveling solo, with family, or in a large group, we offer suitable vehicle options for every type of traveler."
}
]
};

const faqData = [
{
question: "Why is Mahabaleshwar a popular destination from Mumbai?",
answer: "Mahabaleshwar is known for its scenic viewpoints, pleasant climate, strawberry farms, waterfalls, and relaxing hill station atmosphere."
},
{
question: "Can I book a one-way cab from Mumbai to Mahabaleshwar?",
answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
},
{
question: "Which vehicle is best for Mumbai to Mahabaleshwar travel?",
answer: "Sedan cars, Ertiga, and Innova Crysta are among the most preferred options due to their comfort and luggage capacity."
},
{
question: "Are same-day return trips available?",
answer: "Yes, customers can book same-day return trips or choose overnight and multi-day travel plans."
},
{
question: "Can families use this cab service for vacations?",
answer: "Yes, many families book Mumbai to Mahabaleshwar cabs for holidays, sightseeing, and weekend getaways."
},
{
question: "Do you provide Tempo Travellers for group tours?",
answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, corporate outings, and group tours."
},
{
question: "Can customers start the journey from Mumbai Airport?",
answer: "Yes, pickups are available from Mumbai Airport, railway stations, hotels, offices, and residential locations."
},
{
question: "Is advance booking recommended for Mahabaleshwar trips?",
answer: "Yes, advance reservations help secure preferred vehicles and ensure a smooth travel experience."
},
{
question: "Can sightseeing stops be included during the trip?",
answer: "Yes, customers can customize their journey with sightseeing stops, restaurants, and other preferred locations."
},
{
question: "How can I book a Mumbai to Mahabaleshwar Cab?",
answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cab Service."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Pratik Deshmukh",
feedback:
"We booked a Mumbai to Mahabaleshwar Cab for a family vacation. The vehicle was clean, comfortable, and the driver was very professional throughout the journey.",
rating: 5
},
{
id: 2,
name: "Mrs. Neha Patwardhan",
feedback:
"Our weekend trip to Mahabaleshwar was wonderful thanks to Mumbai Airport Cab Service. The pickup was on time, the ride was smooth, and the overall experience exceeded expectations.",
rating: 5
}
];
























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];








const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Mahabaleshwar Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-mahabaleshwar-cab.jpg",
"description": "Book Mumbai to Mahabaleshwar cab service for a comfortable and hassle-free journey. Mumbai Airport Cabs offers reliable taxi service with experienced drivers, clean vehicles, affordable fares, and convenient one-way and round-trip options for leisure and family travel.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-mahabaleshwar-cab"
}
};











    return (
        <div>

<Helmet>
  <title>Mumbai to Mahabaleshwar Cab | Taxi Service & Fare | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Mahabaleshwar cab service at affordable rates. Safe and comfortable taxi service with professional drivers, one-way and round-trip options, and reliable travel from Mumbai to Mahabaleshwar."
/>

<meta
 name="keywords"
 content="mumbai to mahabaleshwar cab, mumbai to mahabaleshwar taxi, mumbai to mahabaleshwar taxi fare, car from mumbai to mahabaleshwar, cab service from mumbai to mahabaleshwar, cab fare from mumbai to mahabaleshwar, car hire from mumbai to mahabaleshwar, one way cab mumbai to mahabaleshwar, round trip taxi mumbai to mahabaleshwar, mumbai mahabaleshwar car rental, taxi booking mumbai to mahabaleshwar, affordable cab to mahabaleshwar, outstation cab mumbai to mahabaleshwar, private taxi mumbai to mahabaleshwar, best cab service mumbai to mahabaleshwar"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/113.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitomahabaleshwarcab;